import { safeDefine } from '@breuni-ui/safe-define';
import { Carousel } from '@breuni-ui/carousel';

export default class EntsCarousel extends Carousel {}

safeDefine('ents-carousel', EntsCarousel);
